import axios from 'axios';
import { storage } from 'src/common/localStorage';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8787',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if it exists
api.interceptors.request.use((config) => {
  const { accessToken } = storage.getAuthData();
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

let isRefreshing = false;

// Handle 401 responses (token expired)
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const { refreshToken, user } = storage.getAuthData();

    if (error.response?.status === 401 && !originalRequest._retry && refreshToken) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;

        try {
          const response = await api.post('refresh-token', { refreshToken });
          const { accessToken, refreshToken: newRefreshToken } = response.data;

          // Update stored token
          storage.saveAuthData(accessToken, newRefreshToken, user);

          // Update request header
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;
          return api(originalRequest);
        } catch (refreshError) {
          storage.clearAuthData();
          window.location.href = '/';
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }
    }

    // return Promise.reject(error);
  }
);

export default api;